import { useLazyQuery } from "@apollo/client/react";import { useEffect, useState } from "react";

import { GET_NOTIFICACIONES } from "../../../data/graphQL/queries/MisVisitas/getNotificaciones";
import toast from "react-hot-toast";

export const useGetRows = (idEvaluacion) => {
  const [notificaciones, setNotificaciones] = useState([]);
  const [cabecera, setCabecera] = useState({});

  const [getNotificaciones, { data: dataNotificaciones, loading }] = useLazyQuery(GET_NOTIFICACIONES, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!dataNotificaciones) return;
    const { idPaciente, paciente, estadoPaciente, idEvaluacion,
      programa, plan, notificaciones
    } = dataNotificaciones?.visitaNotificaciones || {};

    setNotificaciones(notificaciones);
    setCabecera((prevCabecera) => ({
      ...prevCabecera,
      idPaciente: idPaciente,
      paciente: paciente,
      estadoPaciente: estadoPaciente,
      idEvaluacion: idEvaluacion,
      programa: programa,
      planCuidado: plan
    }));
	}, [dataNotificaciones]);  

  const handleSearch = () => {
    getNotificaciones({ variables: { idEvaluacion } });
  };

  useEffect(() => {
    if (isNaN(idEvaluacion) || idEvaluacion === null) {
      setNotificaciones([]);
      toast.error('Error al dirigirse a las notificaciones del contrato.');
    } else
    handleSearch();
  }, [idEvaluacion]);

  return {
    notificaciones,
    setNotificaciones,
    cabecera,
    loading,
    totalCount: notificaciones.length || 0,
    handleSearch
  };
};